import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { optionsFromGlobals } from './optionsFactory'

// The agent loader code executes immediately on instantiation.
new BrowserAgent(optionsFromGlobals()); // NOSONAR
